import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GeckoFields, GeckoBtn, GECKO_UTILS, GECKO_CONSTS } from 'ui';
import GeckoStore from 'services/gecko-store';

class TwilioChannelForm extends Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  changeHandler(key, value) {
    const newValue = GECKO_UTILS.setNestedValue(this.props.value, key, value);
    this.props.onChange(newValue);
  }

  fields = [
    {
      key: 'name',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'Channel Title',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.handle',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'Twitter Account',
      width: 'col-xs-12',
      disabledWhen: () => true,
    },
  ];

  renderFieldsOrLoginButton() {
    if (
      this.props.value.configuration &&
      this.props.value.configuration.twitter_id
    ) {
      return (
        <GeckoFields
          fields={this.fields}
          values={this.props.value}
          handler={this.changeHandler.bind(this)}
        />
      );
    } else {
      const apiUrl =
        GeckoStore.redux.get('appState.apiUrl') ||
        process.env.REACT_APP_API_URL;
      return (
        <div className="text-center">
          <GeckoBtn
            name="Sign in with Twitter"
            icon="fab fa-twitter"
            type="primary"
            handler={() => {
              window.location.href = `${apiUrl}/channel/twitter/login`;
            }}
          />
        </div>
      );
    }
  }

  render() {
    return <div>{this.renderFieldsOrLoginButton()}</div>;
  }
}

export default TwilioChannelForm;
